export function clearFilterState ({ filterType, isSmallScreen, allFilters = false, filter }) {
  const changes = {}

  if (filterType === 'age' || allFilters) {
    changes.levels = ''
    changes.ages = ''
  }

  if (filterType === 'location' || allFilters) {
    changes.location_types = ''
    changes.location = ''
    if (filter) {
      changes.location = filter.default_location
      changes.center = []
      changes.bounds = null
      changes.zoom = null
    }
  }

  if (filterType === 'all' || allFilters) {
    if (isSmallScreen) {
      changes.price = '0,100'
      changes.teacher_languages = ''
    }
    changes.flags = ''
    changes.search = ''
  }

  if (filterType === 'price' || allFilters) {
    changes.price = '0,100'
  }

  if (filterType === 'language' || allFilters) {
    changes.teacher_languages = ''
  }

  if (filterType === 'category_tags' || allFilters) {
    changes.category_tags = ''
  }

  return changes
}

export const getNewFilters = (isFullScreenMap, filterType, filters) => {
  if (!filters) {
    return filterType
  }
  let newFilters = []
  const filtersParts = filters.split(',').filter(f => f)

  if (!filtersParts.length) {
    newFilters.push(filterType)
  } else if (filtersParts.includes('map')) {
    // if filtersParts.length > 1 AND filterType = null
    // then the action is ment to close something other than the map (age, location ...)
    if (filterType) {
      newFilters = ['map', filterType]
    } else {
      newFilters = filtersParts.length === 1 ? [] : ['map']
    }
  } else {
    newFilters = filterType ? [filterType] : []
  }

  return newFilters.join(',')
}
